import _ from 'underscore';

const VISIBILITY_TYPES = {
  PRIVATE: {
    name: 'Private',
    value: 0
  },
  PUBLIC: {
    name: 'Public',
    value: 10
  },
  PUBLISHED: {
    name: 'Published',
    value: 20
  }
};

const VISIBILITY_TYPES_BY_VALUE = _.indexBy(VISIBILITY_TYPES, 'value');

class VisibilityHelpersService {
  get VISIBILITY_TYPES() { //eslint-disable-line
    return VISIBILITY_TYPES;
  }

  /**
   * Is the provided venue or event visible by
   * consumers? May be either Public or Published.
   *
   * @method isPublicOrPublished
   * @param {Object} resource - 'event' or 'venue'
   *
   * @returns {Boolean}
   */
  isPublicOrPublished(resource) {
    if (!resource) return null;
    return this.isPublic(resource) || this.isPublished(resource);
  }

  /**
   * Is the provided venue or event private?
   *
   * @method isPrivate
   * @param {Object} resource - 'event' or 'venue'
   *
   * @returns {Boolean}
   */
  isPrivate(resource) { //eslint-disable-line
    if (!resource) return null;

    // Check if undefined
    if (typeof resource.visibility === 'undefined' || resource.visibility === null) return null;
    return resource.visibility === VISIBILITY_TYPES.PRIVATE.value;
  }

  /**
   * Is the provided venue or event public?
   *
   * @method isPublic
   * @param {Object} resource - 'event' or 'venue'
   *
   * @returns {Boolean}
   */
  isPublic(resource) { //eslint-disable-line
    if (!resource) return null;
    return resource.visibility &&
      resource.visibility === VISIBILITY_TYPES.PUBLIC.value;
  }

  /**
   * Is the provided venue or event published?
   *
   * @method isPublished
   * @param {Object} resource - 'event' or 'venue'
   *
   * @returns {Boolean}
   */
  isPublished(resource) { //eslint-disable-line
    if (!resource) return null;
    return resource.visibility &&
      resource.visibility === VISIBILITY_TYPES.PUBLISHED.value;
  }

  isOnTablelist(resource) {
    if (!resource) return null;
    return !!(this.isPublished(resource) && resource.publish && resource.publish.tablelist);
  }

  getVisibilityTypes() { //eslint-disable-line
    return VISIBILITY_TYPES;
  }

  getVisibilityNameFromValue(value) { //eslint-disable-line
    const type = VISIBILITY_TYPES_BY_VALUE[value];
    return (type) ? type.name : null;
  }
}

export default VisibilityHelpersService;



// WEBPACK FOOTER //
// ./src/services/visibilityHelpersService.js